import { Injectable } from '@angular/core';
import { AllocationViewSelectedEntityModel } from '../../models';
import { AllocationViewActionInterface } from '../models';
import { Observable } from 'rxjs';
import { Store } from '@ngxs/store';
import { filter, take } from 'rxjs/operators';
import { AllocationViewActionsFacade } from '../allocation-view-actions.facade';
import { AllocationViewClearActionState } from './allocation-view-clear-action.state';
import {
  AllocationViewClearAction,
  AllocationViewClearActionSetInitialState,
} from './allocation-view-clear-action.actions';

@Injectable({ providedIn: 'root' })
export class AllocationViewClearActionFacade implements AllocationViewActionInterface {
  loaded$: Observable<boolean> = this.store.select(AllocationViewClearActionState.getLoaded);

  constructor(private allocationViewActionsFacade: AllocationViewActionsFacade, private store: Store) {}

  execute(comment?: string): void {
    this.allocationViewActionsFacade.actionIdentifier$
      .pipe(filter(Boolean), take(1))
      .subscribe(({ identifier }: AllocationViewSelectedEntityModel) => {
        this.store.dispatch(new AllocationViewClearAction({ identifier, comment }));
      });
  }

  setInitialState(): void {
    this.store.dispatch(new AllocationViewClearActionSetInitialState());
  }
}
